var map = {
	"./add.svg": 72998,
	"./alarm.svg": 36804,
	"./copy.svg": 51706,
	"./delete.svg": 70668,
	"./exitFullScreen.svg": 92786,
	"./financialManagement.svg": 54779,
	"./language.svg": 89419,
	"./list.svg": 48645,
	"./noshow.svg": 14183,
	"./overview.svg": 88776,
	"./person.svg": 77486,
	"./product.svg": 88858,
	"./report.svg": 56907,
	"./settings.svg": 7326,
	"./show.svg": 57201,
	"./sms.svg": 1400,
	"./update.svg": 44410
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71525;